document.addEventListener("DOMContentLoaded", function () {

  function initJudgeMeBadges() {
    const widgets = document.querySelectorAll('.jdgm-pgi');

    widgets.forEach(widget => {
      const badge = widget.querySelector('.jdgm-prev-badge');
      const stars = widget.querySelector('.jdgm-prev-badge__stars');

      if (!badge || !stars) return;

      // Get dynamic values
      const rating = badge.getAttribute('data-average-rating') || "0";
      const count = badge.getAttribute('data-number-of-reviews') || "0";

      // Build custom layout (reuse stars)
      const customHTML = `
        <div class="custom-jdgm-badge">
          ${stars.outerHTML}
          <span class="average-rating">${parseFloat(rating).toFixed(1)}</span>
          <span>(${count})</span>
        </div>
      `;

      widget.innerHTML = customHTML;
    });
  }

  // Wait for Judge.me render
  setTimeout(initJudgeMeBadges, 1200);

});

// document.addEventListener("DOMContentLoaded", function () {

//   const customizeBtn = document.getElementById("showCustomize");
//   const standardBtn = document.getElementById("standardBuy");
//   const customFields = document.getElementById("customFieldsWrapper");

//   if (!customizeBtn || !standardBtn) return;

//   // 👉 SHOW CUSTOM FIELDS
//   customizeBtn.addEventListener("click", function () {
//     customFields.style.display = "block";
//     customFields.scrollIntoView({ behavior: "smooth" });
//   });

//   // 👉 STANDARD QUICK BUY
//   standardBtn.addEventListener("click", function () {

//     const form = document.querySelector('form[action="/cart/add"]');
//     if (!form) return;

//     const variantId = form.querySelector('[name="id"]').value;

//     // Go directly to checkout
//     window.location.href = `/cart/${variantId}:1`;

//   });

// });

/* this
document.addEventListener("DOMContentLoaded", function () {

  const actions = document.querySelector(".bespoke-actions");

  const checkGPO = setInterval(() => {

    const gpoFields = document.querySelectorAll(".gpo-group");

    if (gpoFields.length > 0) {

      clearInterval(checkGPO);

      if (actions) actions.style.display = "flex";

      // Wrap GPO in container (for smooth toggle)
      let wrapper = document.getElementById("gpoWrapper");

      if (!wrapper) {
        wrapper = document.createElement("div");
        wrapper.id = "gpoWrapper";

        gpoFields.forEach(el => {
          wrapper.appendChild(el);
        });

        actions.insertAdjacentElement("afterend", wrapper);
      }

      // Initially collapsed
      wrapper.style.maxHeight = "0px";
      wrapper.style.overflow = "hidden";
      wrapper.style.transition = "all 0.4s ease";

      const customizeBtn = document.getElementById("showCustomize");
      const standardBtn = document.getElementById("standardBuy");

      let isOpen = false;

      // 👉 TOGGLE OPEN / CLOSE
      customizeBtn.addEventListener("click", function (e) {
        e.preventDefault();

        if (!isOpen) {
          wrapper.style.maxHeight = wrapper.scrollHeight + "px";
          customizeBtn.classList.add("active");
        } else {
          wrapper.style.maxHeight = "0px";
          customizeBtn.classList.remove("active");
        }

        isOpen = !isOpen;
      });

      // 👉 STANDARD CHECKOUT
      standardBtn.addEventListener("click", function (e) {
        e.preventDefault();

        const form = document.querySelector('form[action="/cart/add"]');
        const variantId = form?.querySelector('[name="id"]')?.value;

        if (variantId) {
          window.location.href = `/cart/${variantId}:1`;
        }
      });

    }

  }, 300);

});

document.getElementById("showCustomize").addEventListener("click", function(e){
  e.preventDefault();

  const wrapper = document.getElementById("customizeWrapper");

  if (wrapper.style.display === "none") {
    wrapper.style.display = "block";
  } else {
    wrapper.style.display = "none";
  }
});*/

// document.addEventListener("DOMContentLoaded", function () {

//   const btn = document.getElementById("showCustomize");
//   const target = document.querySelector(".product-block-cuotom");

//   if (!btn || !target) return;

//   btn.addEventListener("click", function (e) {
//     e.preventDefault();

//     target.classList.toggle("active");
//   });

// });

document.addEventListener("DOMContentLoaded", function () {

  const customizeBtn = document.getElementById("showCustomize");
  const wrapper = document.querySelector(".product-block-cuotom-wrapper");
  const form = document.querySelector(".bespoke-form");

  if (!customizeBtn) return;

  let isOpen = false;

  customizeBtn.addEventListener("click", function (e) {
    e.preventDefault();

    // Toggle fields
    if (wrapper) {
      wrapper.classList.toggle("active");
    }

    // Toggle Add to Cart
    if (form) {
      form.classList.toggle("active");
    }

    isOpen = !isOpen;
  });

});

document.addEventListener("DOMContentLoaded", function () {

  const standardBtn = document.getElementById("standardBuy");

  if (!standardBtn) return;

  standardBtn.addEventListener("click", function (e) {
    e.preventDefault();

    const form = document.querySelector('form[action="/cart/add"]');

    if (!form) {
      console.log("Form not found");
      return;
    }

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(data => {
      // 👉 redirect to checkout
      window.location.href = "/checkout";
    })
    .catch(err => {
      console.error("Error:", err);
    });

  });

});

// document.addEventListener('click', function(e) {
//   const btn = e.target.closest('[class*="js-modal-open-quick-modal-"]');
//   if (!btn) return;

//   e.preventDefault();
//   e.stopPropagation();

//   const match = btn.className.match(/js-modal-open-quick-modal-(\d+)/);
//   if (!match) return;

//   const productId = match[1];
//   const modalId = 'QuickShopModal-' + productId;

//   const modal = new theme.Modals(modalId, 'quick-shop');
//   modal.open();

//   const modalEl = document.getElementById(modalId);
//   const holder = modalEl.querySelector('[id^="QuickShopHolder-"]');

//   if (holder && holder.innerHTML.trim() === '') {
//     const handle = holder.id.replace('QuickShopHolder-', '');

//     fetch('/products/' + handle + '?view=quick')
//       .then(res => res.text())
//       .then(html => {
//         holder.innerHTML = html;
//       });
//   }
// });

// Custom

// OPEN QUICK VIEW
document.addEventListener('click', function(e) {

  const btn = e.target.closest('.quick-view-btn');
  if (!btn) return;

  e.preventDefault();

  const handle = btn.dataset.handle;

  fetch(`/products/${handle}?view=quick-view`)
    .then(res => res.text())
    .then(html => {

      const container = document.getElementById('qv-content-inner');
      container.innerHTML = html;

      const drawer = document.getElementById('quickViewDrawer');
      drawer.classList.add('open');

      document.body.style.overflow = 'hidden'; // lock scroll
    });

});


// CLOSE POPUP (overlay + cross)
document.addEventListener('click', function(e) {

  if (
    e.target.classList.contains('qv-overlay') ||
    e.target.classList.contains('qv-close')
  ) {
    const drawer = document.getElementById('quickViewDrawer');
    drawer.classList.remove('open');

    document.body.style.overflow = 'auto';
  }

});


// CLICK SIZE → ADD TO CART
// document.addEventListener('click', function(e) {

//   const size = e.target.closest('.qv-size');
//   if (!size) return;

//   const id = size.dataset.id;
//   const available = size.dataset.available;

//   if (available === "false") return;

//   // active UI
//   document.querySelectorAll('.qv-size').forEach(el => el.classList.remove('active'));
//   size.classList.add('active');

//   // ADD TO CART
//   fetch('/cart/add.js', {
//   method: 'POST',
//   headers: {'Content-Type': 'application/json'},
//   body: JSON.stringify({
//     id: id,
//     quantity: 1
//   })
// })
// .then(() => {

//   // 1. Get updated cart
//   return fetch('/cart.js');
// })
// .then(res => res.json())
// .then(cart => {

//   // 2. Rebuild cart UI (Impulse)
//   document.dispatchEvent(new CustomEvent('cart:build', {
//     detail: cart
//   }));

//   // 3. OPEN CART DRAWER (IMPORTANT)
//   document.dispatchEvent(new CustomEvent('cart:open'));

//   // 4. Close popup
//   document.getElementById('quickViewDrawer').classList.remove('open');
//   document.body.style.overflow = 'auto';

// });

// });

// QUICK VIEW + CUSTOM WAIST

document.addEventListener('DOMContentLoaded', function () {

  // SIZE / COLOR CLICK
  document.addEventListener('click', function(e) {

    const el = e.target.closest('.qv-size, .qv-color');

    if (!el) return;

    if (el.closest('form')) return;

    const id = el.dataset.id;
    const available = el.dataset.available;

    if (available !== "true") return;

    const text = el.textContent.trim().toLowerCase();

    // CUSTOM BUTTON
    if (text === 'custom') {

      const popup = document.getElementById('customMeasurementPopup');

      popup.classList.add('open');

      document.getElementById('customVariantId').value = id;

      return;
    }

    // NORMAL AUTO ADD
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: id,
        quantity: 1
      })
    })
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => {

      document.dispatchEvent(
        new CustomEvent('cart:build', { detail: cart })
      );

      document.dispatchEvent(
        new CustomEvent('cart:open')
      );

      document
        .getElementById('quickViewDrawer')
        .classList.remove('open');

      document.body.style.overflow = 'auto';

    });

  });


  // CUSTOM FORM SUBMIT
  const customForm = document.getElementById('customMeasurementForm');

  if (customForm) {

    customForm.addEventListener('submit', function(e) {

      e.preventDefault();

      const id = document.getElementById('customVariantId').value;

      const waist = document.getElementById('customWaist').value;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: id,
          quantity: 1,
          properties: {
            Waist: waist
          }
        })
      })
      .then(() => fetch('/cart.js'))
      .then(res => res.json())
      .then(cart => {

        document.dispatchEvent(
          new CustomEvent('cart:build', { detail: cart })
        );

        document.dispatchEvent(
          new CustomEvent('cart:open')
        );

        document
          .getElementById('customMeasurementPopup')
          .classList.remove('open');

        document
          .getElementById('quickViewDrawer')
          .classList.remove('open');

        document.body.style.overflow = 'auto';

      });

    });

  }


  // CLOSE POPUP
  document.addEventListener('click', function(e) {

    if (
      e.target.closest('.custom-popup-close') ||
      e.target.classList.contains('custom-popup-overlay')
    ) {

      document
        .getElementById('customMeasurementPopup')
        .classList.remove('open');
    }

  });

});
// this is for multivariation
/*document.addEventListener('click', function(e) {

  const el = e.target.closest('.qv-size, .qv-color');
  if (!el) return;

  const wrapper = el.closest('.qv-option-values');

  // active UI
  wrapper.querySelectorAll('.qv-size, .qv-color').forEach(item => {
    item.classList.remove('active');
  });
  el.classList.add('active');

  // collect selected values
  let selectedOptions = [];

  document.querySelectorAll('.qv-option').forEach(option => {
    const active = option.querySelector('.active');
    if (active) {
      selectedOptions.push(active.dataset.value);
    }
  });

  // get variants
  const variants = JSON.parse(document.getElementById('qv-variants-json').textContent);

  // find matching variant
  const match = variants.find(variant => {
    return variant.options.every((opt, i) => opt === selectedOptions[i]);
  });

  if (match) {
    document.getElementById('qv-variant-select').value = match.id;
  }

});*/